import { render, staticRenderFns } from "./AccountTypeList.vue?vue&type=template&id=775f4cda&"
import script from "./AccountTypeList.vue?vue&type=script&lang=ts&"
export * from "./AccountTypeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('775f4cda')) {
      api.createRecord('775f4cda', component.options)
    } else {
      api.reload('775f4cda', component.options)
    }
    module.hot.accept("./AccountTypeList.vue?vue&type=template&id=775f4cda&", function () {
      api.rerender('775f4cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/accountType/AccountTypeList.vue"
export default component.exports